import { Link } from 'react-router-dom';
import './Navbar.css';

function Logo() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="8" r="5" fill="#6C63FF" />
      <circle cx="7" cy="20" r="4" fill="#6C63FF" opacity="0.6" />
      <circle cx="21" cy="20" r="4" fill="#6C63FF" opacity="0.6" />
    </svg>
  );
}

function Navbar() {
  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <Logo />
        <span className="navbar-brand-text">AttendX</span>
      </Link>
      <div className="navbar-links">
        <Link to="/" className="navbar-link">Home</Link>
        <a href="#features" className="navbar-link">Features</a>
        <a href="#how-it-works" className="navbar-link">How It Works</a>
        <Link to="/templates" className="navbar-link">Templates</Link>
      </div>
      <div className="navbar-actions">
        <Link to="/login" className="navbar-login">Login</Link>
        <Link to="/signup" className="navbar-signup">Sign Up</Link>
      </div>
    </nav>
  );
}

export default Navbar;
